import React from "react";
import { Translation } from "react-i18next";

interface IPropertyMeasurement {
    name: string
    color: string,
    count?: string;
    isAutoLine?: any;
    selectedDirection?: any;
    isActive?: boolean;
}

export default class PropertyMeasurement extends React.Component<IPropertyMeasurement> {
    public render() {
        return (
            <Translation>
                {
                    t =>
                        <div>
                            <div className="text-center">
                                <div className={this.props.isActive ? "box-outer-active" : "box-outer"} style={{ background: this.props.color || "green" }} />
                                <div className={this.props.isActive ? "box-inner-active" : "box-inner"}>
                                    <div className="position-box-name">{this.props.name}</div>
                                    <div className="text-center" style={{ "height": "40%" }} >
                                        {this.props.isAutoLine ? this.props.selectedDirection !== undefined &&
                                            <span className="ml-1" style={{ fontSize: 12 }}>
                                                {this.props.selectedDirection.totalCounts}({this.props.selectedDirection.totalCounts})
                                        </span> :
                                            this.props.selectedDirection !== undefined &&
                                            <span className="ml-1" style={{ fontSize: 12 }}>
                                                {this.props.selectedDirection.completedCounts}({this.props.selectedDirection.totalCounts})
                                        </span>}
                                    </div>
                                </div>
                            </div>
                        </div>
                }
            </Translation>
        )
    }
}
